import swal from "sweetalert";
import {
  formatError,
  login,
  runLogoutTimer,
  saveTokenInLocalStorage,
  signUp,
} from "../../services/AuthService";

export const SIGNUP_CONFIRMED_ACTION = "[signup action] confirmed signup";
export const SIGNUP_FAILED_ACTION = "[signup action] failed signup";
export const LOGIN_CONFIRMED_ACTION = "[login action] confirmed login";
export const LOGIN_FAILED_ACTION = "[login action] failed login";
export const LOADING_TOGGLE_ACTION = "[Loading action] toggle loading";
export const LOGOUT_ACTION = "[Logout action] logout action";
export const APP_SETTING = "[App setting] app setting";

export function signupAction(email, password, history) {
  return (dispatch) => {
    signUp(email, password)
      .then((response) => {
        saveTokenInLocalStorage(response.data);
        runLogoutTimer(dispatch, response.data.expiresIn * 1000, history);
        dispatch(confirmedSignupAction(response.data));
        history.push("/users");
      })
      .catch((error) => {
        console.log(error);
        const errorMessage = formatError(error.response.data);
        dispatch(signupFailedAction(errorMessage));
      });
  };
}

export function logout(history) {
  localStorage.removeItem("userDetails");
  localStorage.removeItem("viewAsUser");
  history.push("/login");
  return {
    type: LOGOUT_ACTION,
  };
}

export function loginAction(email, password, history) {
  return (dispatch) => {
    login(email, password)
      .then((response) => {
        if (response.data.user.role === "agent") {
          swal(
            "Oops",
            "You are not Authorised to access this Application",
            "error",
            { button: "OK" }
          );
          return;
        }
        const data = {
          idToken: response.data.tokens.access.token,
          expireDate: response.data.tokens.access.expires,
          displayName: response.data.user.name,
          email: response.data.user.email,
          role: response.data.user.role,
          userId: response.data.user.id,
          registered: true,
          expiresIn: response.data.tokens.access.expiresIn,
          refreshToken: response.data.tokens.refresh.token,
          refreshExpireDate: response.data.tokens.refresh.expires,
        };
        saveTokenInLocalStorage(data);
        runLogoutTimer(
          dispatch,
          response.data.tokens.access.expiresIn * 1000,
          history
        );
        dispatch(loginConfirmedAction(data));
        history.push("/users");
      })
      .catch((error) => {
        const errorMessage = formatError(error.response.data);
        dispatch(loginFailedAction(errorMessage));
      });
  };
}

export function loginFailedAction(data) {
  return {
    type: LOGIN_FAILED_ACTION,
    payload: data,
  };
}

export function loginConfirmedAction(data) {
  return {
    type: LOGIN_CONFIRMED_ACTION,
    payload: data,
  };
}

export function confirmedSignupAction(payload) {
  return {
    type: SIGNUP_CONFIRMED_ACTION,
    payload,
  };
}

export function signupFailedAction(message) {
  return {
    type: SIGNUP_FAILED_ACTION,
    payload: message,
  };
}

export function loadingToggleAction(status) {
  return {
    type: LOADING_TOGGLE_ACTION,
    payload: status,
  };
}

export function setAppSetting(appSetting) {
  return {
    type: APP_SETTING,
    payload: appSetting,
  };
}
